import { css } from "@linaria/core";
import { styled } from "@linaria/react";
import React, { useCallback, useEffect, useRef, useState } from "react";
import Text from "@components/Text";
import { themeDefault } from "src/theme-revamp";
import Stepper from "@components/_Revamp/Stepper";
import PaymentMessageBox from "./components/PaymentMessageBox";
import Button from "@components/_Revamp/Button";
import Input from "@components/_Revamp/Input";
import { calculateSpacer } from "../../../utils/spaceCalculation";
import { scrollToRef } from "../../../utils/scrollScript";
import { Checkbox } from "@components/_Revamp/Checkbox";
import Dropdown from "@components/_Revamp/DropdownInput";
import infoIcon from "@assets/icon/info-gray-solid.svg";
import { useAvivaSelector } from "@redux/hook";
import { useDispatch, useSelector } from "react-redux";
import {
  completePaymentInfoStep,
  updateBankId,
  updateCardHolderName,
  updateIsCPFOnly,
  updateOtherBank,
  updatePaymentInfoData,
  updatePremiumPaymentMethod,
} from "@redux/slices/MLTC_R3/step5Slice";
import {
  PaymentForm,
  PaymentPremiumAmount,
} from "@models/MLTC_R3/Payment.model";
import { validate, validateCpf } from "./service";
import useForm from "@utils/useForm";
import Bullet from "@components/_Revamp/Bullet";
import { useHistory } from "react-router-dom";
import { setLoadingState } from "@redux/slices/loadingSlice";
import { GAAviva, MLTC_R3_JOURNEY_NAME } from "@utils/gaAvivaR3";
import { Step } from "@components/_Revamp/Stepper/Stepper";
import BottomSheet from "@components/_Revamp/BottomSheet";
import { Helpers } from "@utils/helpers";
import {
  Coverages,
  SQSPocketRequest,
  SQSPocketResponse,
} from "@models/MLTC/SQSPocketRequest.model";
import { find, get } from "lodash";
import { PaymentRequest } from "@models/MLTC/PaymentRequest.model";
import { UrlAnalyticTrackingModel } from "@models/MLTC_R3/UrlAnalytic.model";
import {
  getPolicyNo,
  postPayment,
  savePayment,
  sendMailMltc,
} from "@api/index";
import {
  updatePolicyNo,
  updateReferenceNo,
} from "@redux/slices/MLTC_R3/step5Slice";
import { Tooltip } from "@components/_Revamp/Tooltip/Tooltip";

const Payment = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  //TODO : Get previous data from step 1 to 4;

  //TODO : Get Current Total amount - s$600;
  //Get NRIC from person data
  //Selector
  const banksList = useAvivaSelector((state) => state.staticData.banks);
  const paymentStatus = useAvivaSelector(
    (state) => state.mltcR3Step5.paymentStatus
  );
  const sqsQuotation = useAvivaSelector(
    (state) => state.mltcR3Step2.sqsQuotation
  );
  const myInfoForm = useAvivaSelector((state) => state.mltcR3Step4.myInfoForm);
  const isMyInfoCompleted = useAvivaSelector(state=>state.mltcR3Step4.isMyInfoStepCompleted)
  const isDeclarationCompleted = useAvivaSelector(state=>state.mltcR3Step4.completedDeclarationStep)
  const isStep4Completed = useAvivaSelector(
    (state) => (state.mltcR3Step4.isCompleted && state.mltcR3Step4.isMyInfoStepCompleted)
  );
  const gioDeclaration = useAvivaSelector(state => state.mltcR3Step2.gioDeclaration);
  const cstopupCampaignValidity = useAvivaSelector(state => state.mltcR3Step2.cstopupCampaignValidity);
  const quoteRawResponse = useAvivaSelector(
    (state) => state.mltcR3Step2.quoteRawResponse
  );
  const premiumPayment = useAvivaSelector(
    (state) => state.mltcR3Step5.premiumPaymentMethod
  );
  const retrieveMyInfo = useAvivaSelector(
    (state) => state.mltcR3Step4.retrievedMyInfo
  );
  const initValue = useAvivaSelector((state) => state.mltcR3Step1.coverage);
  const personalDetails = useAvivaSelector(
    (state) => state.mltcR3Step4.personalDetails
  );
  const paymentInfoData = useAvivaSelector(
    (state) => state.mltcR3Step5.paymentInfoData
  );
  const transactionId = useAvivaSelector(
    (state) => state.mltcR3Step2.transactionId
  );
  const qrClientDetails = useAvivaSelector(
    (state) => state.mltcR3Step5.qrClientDetails,
  );
  const validQRClient = qrClientDetails?.status === "SUCCESS";
  
  //-------------GET DATA FROM REDUX
  const totalcpfAmount = sqsQuotation?.discountedTotalFirstYrPremium
    ? sqsQuotation?.discountedTotalFirstYrPremium.toFixed(2)
    : "0";

  const [nric, setNric] = useState(myInfoForm?.nric);
  //-------------GET DATA FROM REDUX

  const [cpfCreditCardAmount, setCpfCreditCardAmount] = useState<any>(0);
  const [cpfFirstYearCreditCardAmount, setCpfFirstYearCreditCardAmount] = useState<any>(0);
  const [cpfAmountFormCompleted, setCpfAmountFormCompleted] =
    useState<boolean>(false);
  const [isCPFOnly, setCPFOnly] = useState<boolean>(true);
  const [proceedPayment, setProceedPayment] = useState<boolean>(false);

  const [creditCardHolderName, setCreditCardHolderName] = useState<string>("");
  const [creditCardBankCode, setCreditCardBankCode] = useState<string>("");
  const [creditCardOthersBank, setCreditCardOthersBank] = useState<string>("");
  const [policyChecked, setPolicyChecked] = useState<boolean>(true);
  const [newBankObj, setNewBankObj] = useState<any>();
  const [aaTracking, setAATracking] = useState<string[]>([]);

  const creditCardDetailRef = useRef<null | HTMLDivElement>(null);
  const cpfAmountRef = useRef<null | HTMLDivElement>(null);
  const SpacerRef = useRef<null | HTMLDivElement>(null);

  const {
    values: paymentInfoValues,
    errors: paymentInfoValuesErrors,
    handleChange: paymentInfoChanges,
    patchValue: paymentInfoPatchValue,
    formValid: paymentInfoValid,
  } = useForm(new PaymentForm(null), () => {}, validate);
  const {
    values: paymentPremiumValues,
    errors: paymentPremiumErrors,
    handleChange: paymentPremiunChanges,
    patchValue: paymentPremiunPatchValue,
    formValid: paymentPremiunFormValid,
  } = useForm(
    new PaymentPremiumAmount({
      cpfMediSaveAmount: totalcpfAmount,
      creditCardAmount: cpfCreditCardAmount,
    }),
    () => {},
    validateCpf
  );

  const [isLoaded, setLoaded] = useState<boolean>(false);
  const campaignDetail = useAvivaSelector(
    (state) => state.loading.campaignDetail
  );
  const basicDetails = useAvivaSelector(state => state.mltcR3Step1.basicDetails);
  const age = basicDetails?.dob
    ? Helpers.getAge(
        new Date(
          `${basicDetails.dob.month}/${basicDetails.dob.day}/${basicDetails.dob.year}`,
        ),
      )
    : null;
  const isEBLTC = campaignDetail?.code === "EBLTC" && campaignDetail?.status !== "EXPIRED" && age !== null && (age >= 31 && age <= 40);
  const paramCC = campaignDetail?.campaignCode
    ? `?cc=${campaignDetail.campaignCode}`
    : "";
  const combineParamCC = campaignDetail?.campaignCode
    ? `&cc=${campaignDetail.campaignCode}`
    : "";
  const analyticUrlParams = useAvivaSelector(
    (state) => state.urlAnalytic.param
  );
  const analyticParam = Helpers.getUrlAnalyticParams(
    paramCC !== "",
    analyticUrlParams
  );
  const EBCampaignCompanyName = useAvivaSelector(
    (state) => state.mltcR3Step5.EBCampaignCompanyName
  );
  const [cpfAmount, setCpfAmount] = useState<number>();
  const [cpfformattedAmount, setcpfformattedAmount] = useState<number>(0);

  // QB-AA-Tracking fix: maps each form name tracked on this page to its journey step.
  const PAYMENT_STEP_INFO: Record<string, { stepName: string; stepNumber: string }> = {
    mltc_payment_summary_form: { stepName: "Premium Payment Summary", stepNumber: "16" },
    mltc_credit_card_details_form: { stepName: "Your Credit Card Payment Details", stepNumber: "17" },
  };

  const trackOnLoad = (formName: string): void => {
    if (!aaTracking.includes(formName)) {
      setAATracking([...aaTracking, formName]);
      const GA = GAAviva.getInstance();
      let { form, page } = GA.digitalData;
      form.name = formName;

      const stepInfo = PAYMENT_STEP_INFO[formName];
      page.journeyName = MLTC_R3_JOURNEY_NAME;
      page.stepName = stepInfo?.stepName || page.stepName;
      page.stepNumber = stepInfo?.stepNumber || page.stepNumber;

      GA.trackPageLoad({ form, page });
    }
  };

  const onCpfAmountChange = (e: any) => {
    setCpfAmountFormCompleted(false);
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9.]/g, "")
    const formattedAmount = Number(parseFloat(sanitizedValue).toFixed(2)) || 0;
    let formattedInitCPFAmount = parseFloat(totalcpfAmount);

    if (formattedInitCPFAmount > 600) {
      if (formattedAmount <= 600) {
        let tempTotalcpfAmount = parseFloat(totalcpfAmount);
        setCpfAmount(e.target.value);
        setcpfformattedAmount(formattedAmount);
        setCpfCreditCardAmount(tempTotalcpfAmount - formattedAmount);
        paymentPremiunPatchValue({
          cpfMediSaveAmount: Number(formattedAmount),
          creditCardAmount: Number(
            Number(tempTotalcpfAmount - formattedAmount).toFixed(2)
          ),
        });
      }
    } else if (formattedAmount <= formattedInitCPFAmount) {
      let tempTotalcpfAmount = parseFloat(totalcpfAmount);
      setCpfAmount(e.target.value);
      setcpfformattedAmount(formattedAmount);
      setCpfCreditCardAmount(tempTotalcpfAmount - formattedAmount);
      paymentPremiunPatchValue({
        cpfMediSaveAmount: Number(formattedAmount),
        creditCardAmount: Number(
          Number(tempTotalcpfAmount - formattedAmount).toFixed(2)
        ),
      });
    }
  };

  const onCpfAmountBlur = (e: any) => {
    if (cpfformattedAmount === 0) {
      onCpfAmountChange({ target: { value: "$0.00" } });
    }
  };

  // const currencyMask = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   let value = e.target.value;
  //   value = value.replace(/\D/g, "");
  //   value = value.replace(/(\d)(\d{2})$/g, "$1.$2");
  //   value = value.replace(/(?=(\d{3})+(\D))\B/g, ",");
  //   value = `$${value}`;
  //   e.target.value = value;
  //   return e;
  // };

  const currencyMask = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value.replace(/\D/g, "");

    if (!value) {
      e.target.value = "$0.00";
      return e;
    }

    const numberValue = (Number(value) / 100).toFixed(2);

    // add thousand separators
    const formatted = numberValue.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    e.target.value = `$${formatted}`;
    return e;
  };

  const onConfirmCpf = () => {
    setCPFOnly(!(cpfCreditCardAmount > 0));
    dispatch(
      updatePremiumPaymentMethod({
        ...paymentPremiumValues,
        cpfFirstYearCreditCardAmount: cpfFirstYearCreditCardAmount,
      }),
    );
    setProceedPayment(true);
  };

  const onCancelCpf = () => {
    paymentInfoPatchValue({ isAuthorised: true });
    setCPFOnly(!(cpfCreditCardAmount > 0));
    console.log("isCPF only", cpfCreditCardAmount > 0);

    dispatch(
      updatePremiumPaymentMethod({
        cpfMediSaveAmount: "",
        creditCardAmount: "",
        cpfFirstYearCreditCardAmount: "",
      })
    );
    setCpfAmountFormCompleted(false);

    history.push("/mltc/review" + paramCC + analyticParam);
  };

  const onClickPaymentInfoComplete = () => {
    //Set sub step payment info completed!
    dispatch(completePaymentInfoStep(true));
    dispatch(updateCardHolderName(creditCardHolderName));
    dispatch(updateBankId(parseInt(creditCardBankCode)));
    dispatch(updateOtherBank(creditCardOthersBank));
    dispatch(updateIsCPFOnly(isCPFOnly));

    //!Store the useform values for next step usage
    dispatch(updatePaymentInfoData(paymentInfoValues));
    console.log("Dispatch update updatePaymentInfoData", paymentInfoValues);

    proceedNextProcess();
  };

  const proceedNextProcess = () => {
    if (!!campaignDetail && campaignDetail?.code !== "MLO1" && campaignDetail?.code !== "EBLTC") {
      processPayment();
    } else {
      history.push("/mltc/advisor" + paramCC + analyticParam);
    }
  };

  const processPayment = async () => {
    dispatch(setLoadingState(true));
    const pocket = new SQSPocketRequest(quoteRawResponse);
    const coverage: Coverages | any | undefined = find(pocket.coverages, {
      type: "P",
    });
    console.log(
      "premiumPayment?.creditCardAmount",
      premiumPayment?.creditCardAmount
    );
    const totalPayablePremium = Helpers.toTwoDecimal(
      premiumPayment?.creditCardAmount
    );

    const payload = new PaymentRequest({
      transactionId,
      amount: totalPayablePremium,
      productName: "MLTC",
      contractCode: coverage?.productCode || "",
    });
    console.log("processPayment data", payload, coverage?.productCode);
    onSavePayment(coverage?.productCode || "" || "", payload);
  };

  const onSuccessPayment = useCallback(
    async (payload: any) => {
      dispatch(setLoadingState(true));
      try {
        const quotation: SQSPocketResponse = new SQSPocketResponse(
          quoteRawResponse
        );
        const coverage: Coverages | undefined = find(quotation.coverages, {
          type: "P",
        });
        const response = await getPolicyNo(payload, 3, retrieveMyInfo?.id);
        const policyNo = get(response, "data");
        if (policyNo) {
          dispatch(updatePolicyNo(String(policyNo)));
          dispatch(setLoadingState(false));
          // trackFormSubmmit();
          sendMailMltc(payload, 3, retrieveMyInfo?.id); // , quotation.totalAftDisOriginalPremiumAmt, quotation.monthlyBenefit);
          // await onSavePayment(policyNo);
          history.push("/mltc/thank-you" + paramCC + analyticParam);
        } else {
          history.push("/mltc/something-wrong" + paramCC + analyticParam);
          dispatch(setLoadingState(false));
        }
      } catch (err) {
        // trackFormSubmmit(get(err, 'message'));
        dispatch(setLoadingState(false));
        history.push("/mltc/something-wrong" + paramCC + analyticParam);
      }
    },
    [
      analyticParam,
      dispatch,
      history,
      paramCC,
      quoteRawResponse,
      retrieveMyInfo?.id,
    ]
  );

  const onSavePayment = useCallback(
    async (contractCode: string, paymentPayload: any, policyNo?: string) => {
      const quotation: SQSPocketResponse = new SQSPocketResponse(
        quoteRawResponse
      );
      const coverage: Coverages | undefined = find(quotation.coverages, {
        type: "P",
      });
      // const totalPayablePremium = Number(quotation.dpiPremium.totalPremium.value.toString().replace('S$', '')) || 1;
      const totalPayablePremium = premiumPayment?.creditCardAmount;
      let sourceOfFunds = "";
      console.log("onSavePayment isCPFONly", isCPFOnly);
      console.log("onSavePayment totalPayablePremium", totalPayablePremium);
      if (!isCPFOnly) {
        paymentInfoValues["fund"]?.forEach((item: string) => {
          const f_item = item === "other" ? `OTH` : item;
          sourceOfFunds = sourceOfFunds
            ? `${sourceOfFunds}|${f_item},${
                item === "other" ? paymentInfoValues["otherFund"] : "Y"
              }`
            : `${f_item},${
                item === "other" ? paymentInfoValues["otherFund"] : "Y"
              }`;
        });
      }
      const cpfAmt = premiumPayment?.cpfMediSaveAmount || 0;
      const ccAmt = premiumPayment?.creditCardAmount || 0;
      const campaigns = [
        ...(gioDeclaration === "GIO"
          ? [{ code: "GIO", campaignDeclaration: true }]
          : gioDeclaration === "NON GIO"
          ? [{ code: "GIO", campaignDeclaration: false }]
          : []),

        ...(cstopupCampaignValidity ? [{ code: "CSTOPUP" }] : []),
        ...(isEBLTC ? [{ code: "EBLTC", campaignDeclaration: false, companyName: EBCampaignCompanyName }] : [])
      ];

      const payload = {
        policy: {
          // "policyNumber": policyNo,
          contractCode: contractCode,
          customerId: retrieveMyInfo?.id,
          productId: 3,
          planName: coverage?.name,
          sumAssured: quotation.monthlyBenefit,
          premiumTerm: sqsQuotation?.premiumTerm,
          premiumAmount: coverage?.attributes?.modalPremium,
          premiumPaymentFrequency:
            quotation.coverages[0].attributes?.planPremiumMode,
          totalAnnualPremium: quotation.nonDiscountedTotalPremium || 0,
          afterPromoDiscount: quotation.discountedTotalFirstYrPremium || 0,
          firstYearDiscount: sqsQuotation?.totalFirstYearDiscount,
          perpetualDiscount: sqsQuotation?.totalPerpetualDiscount,
          discountType:
            coverage?.attributes?.discountedPremium?.firstYrDiscType ===
            "percent"
              ? "percentage"
              : coverage?.attributes?.discountedPremium?.firstYrDiscType ===
                "dollar"
              ? "dollar"
              : "",
          promoCode: quotation.promoCode,
          campaignCode: campaignDetail?.campaignCode,
          trackingCodeJson: new UrlAnalyticTrackingModel(analyticUrlParams)
            .trackingCodeJson,
          productCode: initValue?.plan, //quotation?.coverages[0].productCode,
          quotationRespData: quoteRawResponse
            ? JSON.stringify(quoteRawResponse)
            : "{}", //json str
          sourceBusiness: "",
          contractCurrency: "SGD",
          policyIllustrationPDFPath: "",
          agentSourceCode: "",
          agentSourceOfBusiness: "",
          agentDetailsRespData: "{}",
          agentOptionChosen: "NO_AGENT",
          planStructure: sqsQuotation?.planStructure,
          formType: !!campaignDetail ? campaignDetail?.code : "MLO1",
          cpfMedisaveAmount: premiumPayment?.cpfMediSaveAmount,
          premiumTermOption: sqsQuotation?.premiumTermOption,
          premiumTermDesc: sqsQuotation?.premiumTermDesc,
          partnerCode: campaignDetail?.partner,
          annualIncome: myInfoForm?.income, //incomeInfo?.income,
          exactDutiesOccupation: "", //incomeInfo?.duties,
          paymentMode: cpfAmt > 0 ? (ccAmt > 0 ? "CPF_CC" : "CPF") : "CC",
          sourceOfFunds: sourceOfFunds,
          transactionId,
          campaigns
        },
        payment: {
          cardHolderNric: get(personalDetails, "nric", null),
          cardHolderName: get(personalDetails, "fullName", null),
          bankId: Number(paymentInfoValues["bank"]),
          paymentAmount: isEBLTC ? Number(cpfFirstYearCreditCardAmount).toFixed(2) : Number(totalPayablePremium).toFixed(2),
          // referenceNo: referenceNo, //reference no
          otherBank: paymentInfoValues["others"],
        },
      };
      console.log("onSavePayment", payload);
      try {
        console.log("onSavePayment -> In Try");
        dispatch(setLoadingState(true));
        const response = await savePayment(payload);
        console.log("savePayment(payload) response", response);
        const refNo = get(response, "data", "");
        console.log("refno", refNo);
        console.log("savePayment", refNo);
        paymentPayload.referenceNumber = refNo;
        dispatch(updateReferenceNo(String(refNo)));

        if (!isCPFOnly) {
          postPayment(paymentPayload)
            .then((res: any) => {
              console.debug("postPayment", res);
              const paymentUrl = get(res, "data");

              console.log("paymentUrl", paymentUrl);
              // const params = new URLSearchParams(paymentUrl.split('?')[1]);
              // const refNo = params.get('referenceNumber');

              dispatch(updateCardHolderName(paymentInfoValues["name"]));
              dispatch(updateBankId(Number(paymentInfoValues["bank"])));
              dispatch(updateOtherBank(paymentInfoValues["others"]));

              const fullPath =
                window.location.origin +
                window.location.pathname.replace("/index.html", "") +
                "#/mltc/payment?status=processing";
              console.log("fullPath", fullPath);
              console.log("isCpfOnly", isCPFOnly);

              dispatch(setLoadingState(true));
              window.open(paymentUrl, "_self");
            })
            .catch((err: any) => {
              dispatch(setLoadingState(false));
              console.log("postPayment() error", err);
              console.error(err);
            });
        } else {
          dispatch(setLoadingState(false));
          onSuccessPayment(refNo);
        }
      } catch (error) {
        dispatch(setLoadingState(false));
        console.log("onSavePayment() error", error);
        console.log("catch error", error);
      }
    },
    [
      analyticUrlParams,
      campaignDetail,
      dispatch,
      initValue?.plan,
      isCPFOnly,
      myInfoForm?.income,
      onSuccessPayment,
      paymentInfoValues,
      personalDetails,
      premiumPayment?.cpfMediSaveAmount,
      premiumPayment?.creditCardAmount,
      quoteRawResponse,
      retrieveMyInfo?.id,
      sqsQuotation?.planStructure,
      sqsQuotation?.premiumTerm,
      sqsQuotation?.premiumTermDesc,
      sqsQuotation?.premiumTermOption,
      sqsQuotation?.totalFirstYearDiscount,
      sqsQuotation?.totalPerpetualDiscount,
      gioDeclaration,
      cstopupCampaignValidity
    ]
  );

  const modifyingBankListObj = () => {
    const newBankObj = banksList.map(({ code, description }) => ({
      id: code,
      label: description,
    }));
    setNewBankObj(newBankObj);
  };

  const cardHolderNameChange = (e: any) => {
    let formatted_name = e.target.value.replace(/[^a-z/'-\s]/gi, "");
    setCreditCardHolderName(formatted_name);
    paymentInfoChanges({
      target: { value: formatted_name, name: e.target.name },
    });
  };
  const creditCardBankChange = (target: any) => {
    setCreditCardBankCode(target.value);
    paymentInfoChanges(target);
  };
  const creditCardOthersChange = (e: any) => {
    let formatted_name = e.target.value.replace(/[^a-z/'-\s]/gi, "");

    setCreditCardOthersBank(formatted_name);
    paymentInfoChanges({
      target: { value: formatted_name, name: e.target.name },
    });
  };
  const creditCardPolicyCheck = (e: any) => {
    setPolicyChecked(e.target.value);
    let target = {
      target: {
        name: "isAuthorised",
        value: e.target.value,
      },
    };
    paymentInfoChanges(target);
  };

  const initCalculateCPFAmount = () => {
    let totalPremiumAmount = parseFloat(totalcpfAmount);

    if (totalPremiumAmount >= 600) {
      onCpfAmountChange({ target: { value: "$600.00" } });
      paymentPremiunPatchValue({
        cpfMediSaveAmount: 600,
        creditCardAmount: totalPremiumAmount - 600,
      });
      setCPFOnly(false);
      setCpfCreditCardAmount(totalPremiumAmount - 600);
      setCpfFirstYearCreditCardAmount(totalPremiumAmount - 600);
    } else if (totalPremiumAmount < 600.0) {
      onCpfAmountChange({
        target: { value: `$${totalPremiumAmount.toFixed(2)}` },
      });
      paymentPremiunPatchValue({
        cpfMediSaveAmount: totalPremiumAmount,
        creditCardAmount: 0,
      });
      setCPFOnly(true);
      setCpfCreditCardAmount(0.0);
      setCpfFirstYearCreditCardAmount(0.0);
    }

    if (cpfAmountRef.current) {
      cpfAmountRef.current.style.opacity = "1";
      calculateSpacer(cpfAmountRef, SpacerRef, true);
    }
  };
  //Init
  useEffect(() => {
    if (!isStep4Completed) {
      history.push(
        "/mltc/lets-get-started?paymenterror=true" +
          combineParamCC +
          analyticParam
      );
      return;
    }
    if (!isLoaded) {
      dispatch(setLoadingState(true));
      modifyingBankListObj();
      trackOnLoad("mltc_payment_summary_form");

      initCalculateCPFAmount();

      setLoaded(true);
      dispatch(setLoadingState(false));
    }
  }, [dispatch, isLoaded, modifyingBankListObj, setLoaded, totalcpfAmount]);

  useEffect(() => {
    if (myInfoForm && myInfoForm.fullName !== "") {
      paymentInfoPatchValue({ name: myInfoForm.fullName });
      setCreditCardHolderName(myInfoForm.fullName);
    }
  }, [myInfoForm]);

  useEffect(() => {
    setTimeout(() => {
      if (creditCardDetailRef && creditCardDetailRef.current) {
        var elementOffSetTop = creditCardDetailRef.current.offsetTop;
        calculateSpacer(creditCardDetailRef, SpacerRef, false);

        var top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          "",
          top,
          elementOffSetTop,
          300,
          true
        );

        creditCardDetailRef.current.style.opacity = "1";
        trackOnLoad("mltc_credit_card_details_form");
      }
    }, 100);
  }, [cpfAmountFormCompleted]);

  useEffect(() => {
    if (premiumPayment && proceedPayment) {
      console.log("Dispatch update paymentPremiumValues", paymentPremiumValues);
      console.log("isCPFOnly", !(cpfCreditCardAmount > 0));

      paymentInfoPatchValue({ isAuthorised: true });
      if (cpfCreditCardAmount) {
        console.log("Request for credit card information");
        setCpfAmountFormCompleted(true);
        setProceedPayment(false);
      } else {
        dispatch(completePaymentInfoStep(true));
        dispatch(updateIsCPFOnly(!(cpfCreditCardAmount > 0)));
        //TODO : SAVE states and dispatch updated states

        proceedNextProcess();
        setProceedPayment(false);
      }
    }
  }, [premiumPayment]);

  useEffect(()=>{

    if(!myInfoForm?.salutation || !myInfoForm?.income || !myInfoForm.salutation || !isMyInfoCompleted ){
      history.replace("/mltc/my-info")
    return
  }
  if(!isDeclarationCompleted){
    history.replace("/mltc/declaration")
    return
  }

  },[])

  const stepsList: Step[] = [
  {
    label: "Basic Info",
    isCurrentStep: false,
    path: "/mltc/lets-get-started",
    disabled: validQRClient
  },
  {
    label: "Quote",
    isCurrentStep: false,
    path: "/mltc/choose-plan",
  },
  {
    label: "Health Declaration",
    isCurrentStep: false,
    path: "/mltc/health",
    disabled: gioDeclaration === "GIO",
  },
  {
    label: "Start Application",
    isCurrentStep: false,
    path: "/mltc/my-info",
  },
  {
    label: "Review & Payment",
    isCurrentStep: true,
    path: "/mltc/review",
  },
];

  const modalContainerRef = useRef<null | HTMLDivElement>(null);
  const bottomSheet1 = useRef<any>(null);
  const bottomSheet2 = useRef<any>(null);
  const displayModal = (
    content: number,
    xCoord: number,
    yCoord: number,
    type: string = "",
  ) => {
    //When modal visible, body style set overflowY hidden to prevent scrolling
    // document.body.style.overflowY = "hidden";

    if (type === "click") {
      if (bottomSheet1 && bottomSheet2) {
        if (content === 1) bottomSheet1.current?.open();
      }
    } else {
      let childrens = modalContainerRef.current
        ?.children as HTMLCollectionOf<HTMLElement>;

      if (childrens?.length > 0) {
        childrens[content - 1].style.opacity = "1";
        childrens[content - 1].style.left = (xCoord - 70).toString() + "px";
        childrens[content - 1].style.top = yCoord.toString() + "px";
      }

      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "1";
      }
    }
  };

  const hideModal = (content: number, type: string = "") => {
    //When modal hide, body style set overflowY unset to allow scrolling of content
    document.body.style.overflowY = "unset";

    if (type === "click") {
      if (bottomSheet1 && bottomSheet2) {
        if (content === 1) bottomSheet1.current?.close();
      }
    } else {
      if (modalContainerRef && modalContainerRef.current) {
        modalContainerRef.current.style.opacity = "0";
      }

      let childrens = modalContainerRef.current
        ?.children as HTMLCollectionOf<HTMLElement>;
      if (childrens?.length > 0) {
        childrens[content - 1].style.opacity = "0";
      }
    }
  };

  return (
    <Container>
      <FormContainer maxWidth={"588px"} ref={cpfAmountRef}>
        <FormHeaderContainer>
          <FormHeaderTitleContainer marginHorizontal={"0px"}>
            <Text
              align={"center"}
              theme={themeDefault}
              className={HeaderTitleCss}
            >
              Premium Payment Summary
            </Text>
          </FormHeaderTitleContainer>
          <FormHeaderDescriptionContainer>
            <Text theme={themeDefault} className={HeaderDescriptionCss}>
              Select your preferred CPF Medisave Amount.
            </Text>
          </FormHeaderDescriptionContainer>
          {paymentStatus === "unsuccessful" && (
            <FormHeaderDescriptionContainer>
              <ErrorMessageContainer>
                <Bullet
                  children={"Payment unsuccessful, kindly try again"}
                  variant={"error"}
                />
              </ErrorMessageContainer>
            </FormHeaderDescriptionContainer>
          )}
        </FormHeaderContainer>

        <PaymentMessageBox rowGap={"0px"}>
          <Text theme={themeDefault} className={MessageBoxParagraphCss}>
            You can use up to S$600 per calendar year from your CPF MediSave
            account for your premium. In the event that your CPF MediSave
            account has insufficient funds, the remaining balance will be
            charged to your credit card which you have provided below.
          </Text>
        </PaymentMessageBox>

        <FormContentContainer>
          <FormLabel>Account number: {nric}</FormLabel>

          {isEBLTC ? (
            <>
              <div className={campaignDetaiHeaderCss}>
                <span>First-year premium</span>
                <IconElement
                  src={infoIcon}
                  alt="info-icon"
                  onClick={(e: any) => {
                    const targetClientRect = e.target.getBoundingClientRect();
                    displayModal(
                      1,
                      targetClientRect.left + 15,
                      targetClientRect.top + targetClientRect.height,
                      "click",
                    );
                  }}
                  onMouseOver={(e: any) => {
                    const targetClientRect = e.target.getBoundingClientRect();
                    displayModal(
                      1,
                      targetClientRect.left + 15,
                      targetClientRect.top + targetClientRect.height,
                    );
                  }}
                  onMouseLeave={() => hideModal(1)}
                />
              </div>
              <div className={firstPremiumContainerCss}>
                <div className={firstPremiumLabelCss}>CPF MediSave Amount</div>
                <div className={firstPremiumValueCss}>S$1.00</div>
                <div className={firstPremiumLabelCss}>
                  Amount Payable after CPF MediSave deduction
                </div>
                <div className={firstPremiumValueCss}>
                  {" "}
                  <span>Credit Card:</span> S${cpfFirstYearCreditCardAmount.toFixed(2)}
                </div>
              </div>
              <div className={campaignDetaiHeaderCss}>
                Subsequent years' premium
              </div>
              <div className={SubsequestPremiumContainerCss}>
                <div className={subSequentPremiumLabelCss}>
                  CPF MediSave Amount
                </div>
                <div style={{ marginBottom: "-1.5rem" }}>
                  <Input
                    theme={themeDefault}
                    pattern="\d*"
                    textAlign={"center"}
                    variant={"default"}
                    type={"normal"}
                    placeholder="Amount"
                    value={cpfAmount}
                    onBlur={onCpfAmountBlur}
                    onChange={(e) => onCpfAmountChange(currencyMask(e))}
                  ></Input>
                </div>

                <div className={subSequentPremiumLabelCss}>
                  Amount Payable after CPF MediSave deduction
                </div>
                <div className={firstPremiumValueCss}>
                  {" "}
                  <span>Credit Card:</span> S${cpfCreditCardAmount.toFixed(2)}
                </div>
              </div>
            </>
          ) : (
            <>
              <InputContainer>
                <Text theme={themeDefault} className={InputTitleCss}>
                  CPF Medisave Amount
                </Text>
                <Input
                  theme={themeDefault}
                  pattern="\d*"
                  textAlign={"center"}
                  variant={"default"}
                  type={"normal"}
                  placeholder="Amount"
                  value={cpfAmount}
                  onBlur={onCpfAmountBlur}
                  onChange={(e) => onCpfAmountChange(currencyMask(e))}
                ></Input>
              </InputContainer>

              <FormLabel>
                (Amount Payable after CPF MediSave reduction)
              </FormLabel>
              <CreditCardContainer>
                <Text theme={themeDefault} className={InputTitleCss}>
                  Credit Card:
                </Text>
                <Text theme={themeDefault} className={InputTitlePurpleCss}>
                  ${cpfCreditCardAmount.toFixed(2)}
                </Text>
              </CreditCardContainer>
            </>
          )}
        </FormContentContainer>

        <FormButtonContainer>
          <Button
            onClick={onCancelCpf}
            width={"200px"}
            variant={"secondary"}
            theme={themeDefault}
            label={"Back"}
          ></Button>
          <Button
            onClick={onConfirmCpf}
            width={"200px"}
            variant={"default"}
            theme={themeDefault}
            label={"Make payment"}
          ></Button>
        </FormButtonContainer>
      </FormContainer>

      {!isCPFOnly && cpfAmountFormCompleted && (
        <FormContainer maxWidth={"588px"} ref={creditCardDetailRef}>
          <FormHeaderContainer>
            <FormHeaderTitleContainer marginHorizontal={"0px"}>
              <Text
                align={"center"}
                theme={themeDefault}
                className={HeaderTitleCss}
              >
                Your Credit Card Payment Details
              </Text>
            </FormHeaderTitleContainer>
            <FormHeaderDescriptionContainer>
              <Text theme={themeDefault} className={HeaderDescriptionCss}>
                Please ensure you’ve provided your own credit card details
              </Text>
            </FormHeaderDescriptionContainer>
          </FormHeaderContainer>
          <FormContentContainer flexDirection={"column"}>
            <FormContentItemsContainer style={{ marginBottom: 36 }}>
              <FormInputLabel>Cardholder&apos;s name</FormInputLabel>
              <Input
                name={"name"}
                margin={"0"}
                maxLength={30}
                value={paymentInfoValues["name"]}
                onChange={cardHolderNameChange}
              ></Input>
            </FormContentItemsContainer>
            <FormContentItemsContainer style={{ marginBottom: 36 }}>
              <FormInputLabel>Credit Card Issuing Bank</FormInputLabel>
              <Dropdown
                value={
                  banksList.find((e) => e.code === paymentInfoValues["bank"])
                    ?.description
                }
                theme={themeDefault}
                source={newBankObj}
                onChange={creditCardBankChange}
                name="bank"
                placeholder="Please Select"
              />
            </FormContentItemsContainer>
            {paymentInfoValues["bank"] === "11" && (
              <FormContentItemsContainer style={{ marginBottom: 36 }}>
                <FormInputLabel>Others</FormInputLabel>
                <Input
                  placeholder={"Bank Name"}
                  name={"others"}
                  margin={"0"}
                  maxLength={30}
                  value={paymentInfoValues["others"]}
                  onChange={creditCardOthersChange}
                ></Input>
              </FormContentItemsContainer>
            )}
          </FormContentContainer>

          <CheckboxAddressContainer>
            <Checkbox
              checkboxAlignment={"center"}
              checked={paymentInfoValues["isAuthorised"]}
              onChange={creditCardPolicyCheck}
              theme={themeDefault}
            >
              <Text theme={themeDefault} className={paragraphCss}>
                I am buying this insurance policy for myself, and I authorise
                Singapore Life Ltd. to charge the{" "}
                <b>initial and subsequent premium(s)</b> to my credit card
                account for this insurance policy.
              </Text>
            </Checkbox>
          </CheckboxAddressContainer>

          <FormButtonContainer>
            <Button
              margin={"40px auto 0 auto"}
              disabled={
                creditCardHolderName === "" ||
                creditCardBankCode === "" ||
                (creditCardOthersBank === "" &&
                  paymentInfoValues["bank"] === "11") ||
                !policyChecked
              }
              onClick={onClickPaymentInfoComplete}
              width={"200px"}
              variant={"default"}
              theme={themeDefault}
              label={"Proceed"}
            ></Button>
          </FormButtonContainer>
        </FormContainer>
      )}

      <div ref={SpacerRef}></div>

      <Stepper steps={stepsList}></Stepper>

      <ModalContainer className="ModalContainer" ref={modalContainerRef}>
        <div style={{ opacity: 0, position: "absolute" }}>
          <Tooltip maxWidth={384} theme={themeDefault}>
            <PayoutTooltipContainer>
              <h4>First-year premium</h4>
              <p>
                For your first year, you only need to pay S$1 from your CPF
                MediSave. Singlife covers up to S$599, and any remaining cash
                premium will be charged to your credit card.
              </p>
            </PayoutTooltipContainer>
          </Tooltip>
        </div>
      </ModalContainer>

      <BottomSheet />
    </Container>
  );
};

export default Payment;

const firstPremiumLabelCss = css`
  color: #8A8988;
  font-size: 16px;
  font-weight: 600;
`;

const subSequentPremiumLabelCss = css`
  color: #434343;
  font-size: 16px;
  font-weight: 600;
`;

const firstPremiumValueCss = css`
  color: #883E89;
  font-size: 16px;
  font-weight: 600;

  span {
    color: #434343;
  }
`;

const firstPremiumContainerCss = css`
  border-radius: 1.5rem;
  padding: 1.5rem;
  background-color: #FCFCFC;
  border: 1px solid #E6E6E6;
  gap: 1.5rem;
  display: grid;
  margin-top: 1.5rem;
`;

const SubsequestPremiumContainerCss = css`
  border-radius: 1.5rem;
  padding: 1.5rem; 
  background-color: #FFFAFF;
  border: 1px solid #883E89
  gap: 1.5rem;
  display: grid;
  margin-top: 1.5rem;
`;

const campaignDetaiHeaderCss = css`
  font-size: 18px;
  font-weight: 600;
  color: #434343;
  margin-top: 1rem;
  display: flex;
`;

const PayoutTooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  @media screen and (max-width: 768px) {
    row-gap: 16px;
  }
`;

const ModalContainer = styled.div`
  position: fixed;
  display: none;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow-x: hidden;
  background-color: rgba(51, 51, 51, 0.85);
  pointer-events: none;
  opacity: 0;
  transition: opacity 500ms ease;
  box-shadow: none;
  @media screen and (min-width: 768px) {
    display: block;
  }
`;

const IconElement = styled.img`
  width: 20px;
  height: 20px;
  object-fit: contain;
  position: relative;
  top: 3px;
`;

const Container = styled.div`
  position: relative;
  margin: 0 auto;
  max-width: 1230px;
  display: block;
  padding: 0;

  @media screen and (min-width: 768px) {
    padding: 0 24px;
  }
  @media screen and (min-width: 1024) {
  }
`;

const CheckboxAddressContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 20px;
  max-width: 327px;
  margin: 0 auto;
  @media screen and (min-width: 768px) {
    max-width: unset;
    margin: unset;
  }
`;

const InputContainer = styled.div`
  display: block;
  margin: 16px 0 18px 0;
  @media screen and (max-width: 768px) {
    margin: 4px 0 18px 0;
  }
`;
const CreditCardContainer = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: 2px;
  margin-top: 16px;
`;
const ErrorMessageContainer = styled.div`
  margin: 20px 0 0;
  display: flex;
  justify-content: center;
`;

const HeaderTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 140%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-size: 20px;
  }
`;

const InputTitleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  color: #434343;
  margin-bottom: 32px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
const InputTitlePurpleCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 140%;
  color: #883e89;
  margin-bottom: 32px;
  @media screen and (max-width: 768px) {
    font-size: 16px;
  }
`;
const MessageBoxParagraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #434343;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 400;
  }
`;

const FormContainer = styled.div<FormContainerProps>`
  opacity: 0;
  -webkit-transition: opacity 0.5s ease-in;
  -moz-transition: opacity 0.5s ease-in;
  -o-transition: opacity 0.5s ease-in;
  -ms-transition: opacity 0.5s ease-in;
  transition: opacity 0.5s ease-in;
  flex-direction: column;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: 200px auto 100px auto;
  transition: all 0.2s ease;

  @media screen and (min-width: 768px) {
    margin: 200px auto 50px auto;
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  }
  @media screen and (min-width: 1024px) {
    max-width: ${(props) => (props.maxWidth ? props.maxWidth : "unset")};
  }
  @media screen and (min-width: 1250px) {
    margin: ${(props) => (props.margin ? props.margin : "150px auto 0 auto")};
  }
`;
const FormHeaderContainer = styled.div`
  display: block;
  margin: 0 auto 24px;
  max-width: 327px;
  @media screen and (min-width: 768px) {
    margin: 0 auto 48px;
    max-width: 588px;
  }
`;
const FormContentContainer = styled.div<FormContentContainerProps>`
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${(props) =>
    props.flexDirection ? props.flexDirection : "column"};
  justify-content: space-between;
  column-gap: 30px;
  margin-bottom: 30px;
  @media screen and (max-width: 768px) {
    flex-direction: column;
    max-width: 327px;
    margin: 0 auto 30px;
    width: 100%;
  }
`;
const FormContentItemsContainer = styled.div`
  flex: 0 0 45%;
  @media screen and (max-width: 768px) {
    flex: 1;
  }
`;
const FormHeaderTitleContainer = styled.div<FormHeaderTitleContainerProps>`
  display: block;
  margin: 0 ${(props) => props.marginHorizontal};
  margin-bottom: 16px;
  @media screen and (max-width: 768px) {
    padding: 0;
    margin: 0;
    margin-bottom: 16px;
  }
`;

const FormHeaderDescriptionContainer = styled.div`
  display: block;
  margin: 0 50px;
  @media screen and (max-width: 768px) {
    margin: 0 0;
    padding: 0;
  }
`;

const FormButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px auto 50px;
  column-gap: 40px;
  @media screen and (max-width: 768px) {
    column-gap: 0;
    row-gap: 10px;
    margin: 40px auto 0;
    flex-direction: column;
    align-items: center;
    max-width: 327px;
    width: 100%;
  }
`;

const FormInputLabel = styled.label`
  display: block;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #434343;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;

const FormLabel = styled.label`
  display: block;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 180%;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;
const MessageNote = styled.p<MessageNoteProps>`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 140%;
  color: ${(props) => (props.color ? props.color : "#8C8C8C")};
  height: 12px;
`;

const HeaderDescriptionCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 140%;
  text-align: center;
  color: #8a8988;
  @media screen and (max-width: 768px) {
    font-weight: 400;
  }
`;

const paragraphCss = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 140%;
  color: #434343;
  b {
    font-weight: 600;
  }
`;

const container_default_css = css`
  margin-bottom: 0px;
`;
const title_default_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 16px;
  }
`;

const container_with_bg_css = css`
  margin: 24px 0 0 0;
  &:nth-child(1) {
    margin: 64px 0 0 0;
  }
`;
const title_with_bg_css = css`
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 600;
  line-height: 140%;
  @media screen and (max-width: 768px) {
    width: unset;
    font-size: 20px;
  }
`;

export interface FormContainerProps {
  margin?: string;
  maxWidth?: string;
}
export interface MessageNoteProps {
  color?: string;
}
export interface FormContentContainerProps {
  flexDirection?: string;
}

export interface StepInterface {
  label: string;
  isCurrentStep: boolean;
}
export interface FormHeaderTitleContainerProps {
  marginHorizontal: string;
}

const args = {
  theme: themeDefault,
  className: container_with_bg_css,
  title: "Personal Information",
  titleClassName: title_with_bg_css,
  titleColor: "#883E89",
  titleFontSize: 28,
  isExpanded: false,
  showHeaderBackground: true,
  headerBackgroundColor: "#FAFAFA",
  contentMarginLeft: "0",
  contentMarginRight: "0",
  showBottomLine: false,
  bottomLineColor: "#000",
  showExtraElement: true,
};
